import { _ as i } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { resolveComponent as t, openBlock as o, createElementBlock as p, normalizeClass as m, createBlock as a, withCtx as r, renderSlot as d, createCommentVNode as s } from "vue";
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const f = ["invalid", "readonly", "disabled"];
function v(e, n, y, $, b, B) {
  const l = t("OrInputBoxAddon");
  return o(), p("div", {
    ref: "root",
    class: m(e.rootStyles),
    invalid: e.invalid,
    readonly: e.readonly,
    disabled: e.disabled,
    onFocus: n[0] || (n[0] = (k) => e.$emit("focus"))
  }, [
    e.$slots.prepend ? (o(), a(l, {
      key: 0,
      invalid: e.invalid,
      readonly: e.readonly,
      disabled: e.disabled
    }, {
      default: r(() => [
        d(e.$slots, "prepend")
      ]),
      _: 3
    }, 8, ["invalid", "readonly", "disabled"])) : s("", !0),
    d(e.$slots, "default"),
    e.$slots.addon ? (o(), a(l, {
      key: 1,
      invalid: e.invalid,
      readonly: e.readonly,
      disabled: e.disabled
    }, {
      default: r(() => [
        d(e.$slots, "addon")
      ]),
      _: 3
    }, 8, ["invalid", "readonly", "disabled"])) : s("", !0)
  ], 42, f);
}
const A = /* @__PURE__ */ u(i, [["render", v]]);
export {
  A as O
};
//# sourceMappingURL=OrInputBox-6ciokFdU.mjs.map
